<fullscreen-page>
  <navigation-column>
    <div class="h-100 d-flex flex-column">
      <div class="p-2 flex-fill overflow-hidden">
        <dx-data-grid
          class="h-100"
          [dataSource]="templates"
          [rowAlternationEnabled]="true"
          noDataText="{{ 'keine Update Templates im Account' | translate }}"
          [showBorders]="true"
          [(selectedRowKeys)]="selectedRowKeys"
          (onSelectionChanged)="onSelectionChanged($event)"
          (onRowRemoved)="onDeleteClicked($event)"
        >
          <dxo-editing mode="row" [allowDeleting]="true" [allowUpdating]="false" [useIcons]="true"></dxo-editing>
          <dxo-selection mode="single"></dxo-selection>
          <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
          <dxo-search-panel
            [visible]="true"
            [highlightCaseSensitive]="true"
          ></dxo-search-panel>
          <dxo-toolbar>
            <dxi-item location="before" name="searchPanel"></dxi-item>
            <dxi-item location="after">
              <dx-button
                stylingMode="text"
                type="default"
                icon="plus"
                text="{{ 'Neues Update Template' | translate }}"
                (onClick)="addTemplate()"
              ></dx-button>
            </dxi-item>
          </dxo-toolbar>

          <dxo-state-storing
            [enabled]="true"
            type="localStorage"
            storageKey="UpdateTemplatesStateNewUIV3"
          ></dxo-state-storing>

          <dxi-column dataField="name" caption="{{ 'Name' | translate }}"></dxi-column>
        </dx-data-grid>
      </div>
    </div>
  </navigation-column>
  <content-column [helpSwitch]="helpSwitch" look="light">
    <div slot="content" class="h-100 px-3">
      <dx-scroll-view showScrollbar="always">
        <UpdateTemplate *ngIf="selectedTemplate" [template]="selectedTemplate"></UpdateTemplate>
      </dx-scroll-view>
    </div>
  </content-column>
  <help-column class="{{ systemService.showHelp ? '' : 'd-none' }}"></help-column>
</fullscreen-page>
